/*
 * @Author: yexiu
 * @Date: 2024-12-09 10:58:30
 * @LastEditors: monai
 * @LastEditTime: 2025-07-23 15:19:33
 */
import HTTP_Client from './getHttpClient';
import { getQueryString, fnColorLog, fnParamsCheck } from '@activity-business/h5-package-frameworkTool';

const getRule: DevelopToolShare.GetRule = (app, parameter) => {
    // type默认ajax, 默认使用文案
    const {countryCode, reactRule, useAjaxRule} = parameter;
    // 返回加载函数，根据页面展示进行懒加载
    let fnGetRuleData = () => reactRule, isRequestRuleXML = false;
    // 未使用接口 rule
    if (!useAjaxRule) return (reactRule.mas = '未使用插件 ajax 接口获取 rule！', fnGetRuleData);
    // 参数校验、错误提示
    if (fnParamsCheck({countryCode, reactRule})) return fnGetRuleData;
    const ENCRYPT = getQueryString('encrypt');
    if (!ENCRYPT) {
        fnColorLog(['developTool_Share', 'RULE'], 'error', '参数获取失败,请添加加密串参数');
        throw new Error(`[${new Date().toLocaleString()}] developTool_Share RULE, 参数获取失败, 请添加加密串参数!`);
    }
    fnGetRuleData = () => {
        // 未请求过规则页接口
        if (!isRequestRuleXML && (isRequestRuleXML = true)) {
            HTTP_Client(`/activity/center/web/h5/activity/share/decryptConfigsRule?secretValue=${ENCRYPT}`)
            .then(response => {
                const {data: {data, errorCode}} = response;
                if (errorCode != 0) throw response;
                Object.assign(reactRule, data.ruleConfig);
                // const ruleGetAllIndex = ()=> {
                //     const rules = {};
                //     for (const key in data.ruleConfig) {
                //         if (key.startsWith('index_')) {
                //             const index = Number(key.split('_')[1]);
                //             rules[index] = data.ruleConfig[key];
                //         }
                //     }
                //     return rules;
                // }
                // Object.assign(reactRule, {
                //     isEnd: data.isEnd ?? false,
                //     domain: data.domain,
                //     rules: ruleGetAllIndex()
                // });
            })
            .catch(err => {
                console.log(err);
            });
        }
        return reactRule;
    }

    return fnGetRuleData;
};

export default getRule;